import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 24px;
  min-height: calc(100vh - 64px);
  /* Fundo claro com leves realces (verde e amarelo da marca) */
  background:
    radial-gradient(900px 420px at 12% -10%, rgba(146, 178, 31, 0.08), transparent 60%),
    radial-gradient(700px 380px at 88% -18%, rgba(255, 223, 90, 0.07), transparent 55%), #f7f7f7;
  color: #111; /* texto padrão escuro para a página */
`;

export const DetailList = styled.ul`
  margin: 0;
  padding: 0 0 0 0;
  list-style: none;
  display: grid;
  gap: 8px;

  li {
    font-size: 0.95rem;
    color: #333;
    display: flex;
    gap: 6px;
    line-height: 1.35;
  }

  span {
    color: #555;
    min-width: 180px;
  }
`;
